import React from 'react';
import '../styles/Global.css';

import digitalMarketingImg from '../assets/services/digital-marketing.png';
import graphicDesignImg from '../assets/services/graphic-design.png';
import motionGraphicsImg from '../assets/services/motion-graphics.png';
import uiuxImg from '../assets/services/ui-ux.png';
import webDevImg from '../assets/services/web-development.png';
import mobileDevImg from '../assets/services/mobile-development.png';

import Header from './Header';
import Footer from './Footer';

const Services: React.FC = () => (
        <div className="page-container">
            <Header />
            <main className="page-content">
                <section className="services-section">
                    <h1>What we do</h1>
                    <div className="services-list">
                        <div className="service-card">
                            <img src={digitalMarketingImg} alt="Digital Marketing" className="service-img" />
                            <h2>Digital Marketing</h2>
                            <p>
                                Boost your brand’s online presence with our comprehensive digital marketing solutions. We specialize in SEO, SEM, social media campaigns, and content marketing to help you reach and engage your target audience effectively.
                            </p>
                        </div>
                        <div className="service-card">
                            <img src={graphicDesignImg} alt="Graphic Design" className="service-img" />
                            <h2>Graphic Design</h2>
                            <p>
                                Our creative team delivers stunning visuals, from logos and branding to brochures and banners. We ensure your brand stands out with eye-catching and memorable designs tailored to your business needs.
                            </p>
                        </div>
                        <div className="service-card">
                            <img src={motionGraphicsImg} alt="Motion Graphics" className="service-img" />
                            <h2>Motion Graphics</h2>
                            <p>
                                Engage your audience with dynamic motion graphics and animations. We create explainer videos, promotional clips, and animated infographics that bring your ideas to life and communicate your message powerfully.
                            </p>
                        </div>
                        <div className="service-card">
                            <img src={uiuxImg} alt="UI/UX Design" className="service-img" />
                            <h2>UI/UX Design</h2>
                            <p>
                                We craft intuitive and delightful user experiences. Our UI/UX experts focus on usability, accessibility, and aesthetics to ensure your digital products are both beautiful and easy to use.
                            </p>
                        </div>
                        <div className="service-card">
                            <img src={webDevImg} alt="Web Development" className="service-img" />
                            <h2>Web Development</h2>
                            <p>
                                From responsive websites to complex web applications, our developers use the latest technologies to build secure, scalable, and high-performing solutions tailored to your business goals.
                            </p>
                        </div>
                        <div className="service-card">
                            <img src={mobileDevImg} alt="Mobile Development" className="service-img" />
                            <h2>Mobile Development</h2>
                            <p>
                                Reach your customers on the go with custom mobile apps for iOS and Android. We design and develop user-friendly, feature-rich mobile applications that drive engagement and growth.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );

export default Services;